import FuxHTTP from "../../lib/FuxFramework/FuxHTTP";
import APIConfig from "../APIConfig";
import {_WebMenuAPI} from "./_WebMenuAPI";

export const MenuDigitaleAPI = {
    WebMenu: _WebMenuAPI
}